<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>사고 발생 상황 보고 (최초보고)</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>보고 목적</div>
          <span v-if="isPrint" class="print-input">{{ form.inputA_1 }}</span>
          <div v-else class="w-full flex-1 flex gap-4" style="align-self: center;">
            <vs-radio v-model="form.inputA_1" :disabled="board.readonly" vs-name="object" vs-value="방침필요">방침필요</vs-radio>
            <vs-radio v-model="form.inputA_1" :disabled="board.readonly" vs-name="object" vs-value="상황">상황</vs-radio>
            <vs-radio v-model="form.inputA_1" :disabled="board.readonly" vs-name="object" vs-value="결과보고(지시사항 등)">결과보고(지시사항 등)</vs-radio>
            <vs-radio v-model="form.inputA_1" :disabled="board.readonly" vs-name="object" vs-value="회의/행사">회의/행사</vs-radio>
            <vs-radio v-model="form.inputA_1" :disabled="board.readonly" vs-name="object" vs-value="기타">기타</vs-radio>
          </div>
        </div>
        <div class="writeGridLineItem">
          <div>시급성</div>
          <span v-if="isPrint" class="print-input">{{ form.inputA_2 }}</span>
          <div v-else class="w-full flex-1 flex gap-4" style="align-self: center;">
            <vs-radio v-model="form.inputA_2" :disabled="board.readonly" vs-name="urgency" vs-value="긴급(중대재해)">긴급(중대재해)</vs-radio>
            <vs-radio v-model="form.inputA_2" :disabled="board.readonly" vs-name="urgency" vs-value="중요">중요</vs-radio>
            <vs-radio v-model="form.inputA_2" :disabled="board.readonly" vs-name="urgency" vs-value="보통">보통</vs-radio>
          </div>
        </div>
        <div class="writeGridLineItem">
          <div>보고 요지</div>
          <span style="align-self: center;">보고서의 핵심 내용을 압축하여 1~2줄로 작성(대책·대안 중심 작성)</span>
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>사고개요</h5>
      <div class="writeGridContainer">
        <div>
          <div>일시</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_1 }} </span>
          <DateSelector v-else :readonly="board.readonly" placeholder="날짜선택" v-model="form.inputB_1" />
        </div>
        <div>
          <div>시간</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_2 }} </span>
          <time-selector v-else :readonly="board.readonly" placeholder="시간선택" v-model="form.inputB_2" />
          <div class="ml-1">경</div>
        </div>
        <div>
          <div>장소</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_3 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_3" />
        </div>
        <div class="writeGridLineItem">
          <div>기본현황</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_4 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_4" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>원인</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_5 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_5" :readonly="board.readonly" placeholder="원인 미상의 지하층 화재발생, 현재 원인 조사 중"/>
        </div>
        <div class="writeGridLineItem">
          <div>피해상황(인명피해)</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_6 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_6" :readonly="board.readonly" placeholder="- 사망 2명(종사자 1, 시민 1)"/>
        </div>
        <div class="writeGridLineItem">
          <div>피해상황(재산피해)</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_7 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_7" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>피해상황(그 밖의 피해)</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_8 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_8" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <table-custom
      class="mt-28px"
      :board="board"
      :is-print="isPrint"
      title="응급조치 사항"
      :tableData="[
        { id: 'cell1', title: '시간', type: 'text', placeholder: '내용' },
        { id: 'cell2', title: '조치 사항', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.tableList1"
    />

    <table-custom
      class="mt-28px"
      :board="board"
      :is-print="isPrint"
      title="향후계획"
      :tableData="[
        { id: 'cell1', title: '내용', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.tableList2"
    />

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="1"
      v-model="form.photoList1"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사고 위치도"
      placeholder="사고 위치"
    />

    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList2"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사고 현장"
      placeholder="사고 현장"
    />

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-28px" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import SearchNavStartEnd from "../../../../components/nav/SearchNavStartEnd.vue";
import FileUploadModule from "../../../modules/FileUploadModule.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";

export default {
  components: {
    PhotoUploadGridModule,
    TableCustom,
    TimeSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    SearchNavStartEnd,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    is내부종사자() {
      return `${this.projectId}` === "2";
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "▪ 의료법인 : 0000단(이사장 : 000 )\n" +
          "▪ 주 소 지 : 00시 000구 000로 00\n" +
          "▪ 의료현황 : 의료진47명(의사6,간호사16, 조무사 25), 4개(재활·가정의학과, 신경외과, 정형외과)\n" +
          "▪ 병상현황 : 44병실, 220병상(지하 1층 재활·통증치료실, 1층 진료실, 2층~11층 입원실)\n" +
          "▪ 규 모 : 지하2층 ~ 지상11층(연면적 0,000㎡)",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",

        tableList1: [ {"cell1":"", "cell2":"",}, {"cell1":"", "cell2":"",} ],
        tableList2: [ {"cell1":"", }, {"cell1":"",} ],

        photoList1: [],
        photoList2: [],
        fileList: [],
      },
    };
  },
  methods: {
  },
};
</script>
